import axios from '../Axios';
import { FORGOTPASSWORD, VERIFYFORGOTPASSWORDTOKEN, CHANGEPASSWORD, RESETPASSWORD } from '../CONSTANTURL';
export const FORGOTPASSWORDAPI = async (data, callback) => {
  await axios
    .post(`${FORGOTPASSWORD}`, data)
    .then((res) => {
      callback(null, res);
    })
    .catch((err) => {
      let { response: { data: { error: { message } = {} } = {} } = {} } = err;
      callback({ message: message });
    });
};

export const VERIFYFORGOTPASSWORDTOKENAPI = async (token, callback) => {
  await axios
    .get(`${VERIFYFORGOTPASSWORDTOKEN}?token=${token}`)
    .then((res) => {
      callback(null, res);
    })
    .catch((err) => {
      let { response: { data: { error: { message } = {} } = {} } = {} } = err;
      callback({ message: message });
    });
};

export const CHANGEPASSWORDAPI = async (token, data, callback) => {
  await axios
    .post(`${CHANGEPASSWORD}?token=${token}`, data)
    .then((res) => {
      callback(null, res);
    })
    .catch((err) => {
      let { response: { data: { error: { message } = {} } = {} } = {} } = err;
      callback({ message: message });
    });
};

export const RESETPASSWORDAPI = async (data, callback) => {
  await axios
    .post(`${RESETPASSWORD}`, data)
    .then((res) => {
      callback(null, res);
    })
    .catch((err) => {
      let { response: { data: { error: { message } = {} } = {} } = {} } = err;
      callback({ message: message });
    });
};